import { memo, useCallback } from 'react';

import { ExternalLinkIcon } from '@air/design-icons';
import { FileStatusButton } from '@air/feature-file-status/ui';

import { useWorkspaceImportsOpenDestination } from '~/components/v2/components/workspace/workspace-imports/useWorkspaceImportsOpenDestination';
import { WorkspaceImportsListItem } from '~/components/v2/components/workspace/workspace-imports/WorkspaceImportsListItem';
import { type WorkspaceImportRow } from '~/components/v2/components/workspace/workspace-imports/workspaceImportTypes';

export type WorkspaceImportsCompletedListItemProps = {
  row: WorkspaceImportRow;
};

export const WorkspaceImportsCompletedListItem = memo(({ row }: WorkspaceImportsCompletedListItemProps) => {
  const { openDestination } = useWorkspaceImportsOpenDestination();
  const openLabel = row.board.id ? 'Open board' : 'Open all media';

  const handleOpen = useCallback(() => {
    openDestination(row.board);
  }, [openDestination, row.board]);

  return (
    <WorkspaceImportsListItem
      actions={
        <FileStatusButton
          appearance="ghost"
          data-testid="WORKSPACE_IMPORTS_ITEM_OPEN"
          label={openLabel}
          onClick={handleOpen}
        >
          <ExternalLinkIcon aria-hidden size="sm" />
        </FileStatusButton>
      }
      dimmed
      row={row}
    />
  );
});

WorkspaceImportsCompletedListItem.displayName = 'WorkspaceImportsCompletedListItem';
